module.exports = __webpack_public_path__ + "img/679178e2d912fb27704d1ca6fe1e4009.svg";